import React from "react";
import Chip from "@hyro-components/Chip";
import { CHANGE_BADGES } from "./reviewChanges.consts";

const ChangeBadge = ({ changeType }) => {
  const badge = CHANGE_BADGES[changeType];
  if (!badge) return null;
  return (
    <Chip
      data-testid={`change-badge-${changeType}`}
      label={badge.label}
      backgroundColorPath={badge.background}
      textColorPath={badge.text}
    />
  );
};

export default ChangeBadge;
